import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import TextField from "../../../Address/Textfield"
import FullNameInput from "../../../FullName/FullName"
import DateField from "../../../DateField/DateField"
import moment from "moment"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {PassportDocumentFormValues} from "./types"
import {birthDateValidation, fullNameValidation, validationErrorMessages} from "./validationSchemas"
import {countryRegex} from "../../../../utilities/validation"

interface PassportDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: PassportDocumentFormValues
	onSubmit: (values: PassportDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	fullName: fullNameValidation,
	dateOfBirth: birthDateValidation,
	nationality: Yup.string()
		.matches(new RegExp(countryRegex), validationErrorMessages.nationality.invalid)
		.required(validationErrorMessages.nationality.required),
	passport: Yup.string().required(validationErrorMessages.passport.required),
})

export const PassportDocumentForm = ({documentType, initialValues, onSubmit, formId}: PassportDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Name</div>
					<div className="form-row two">
						<FullNameInput fullName={values.fullName} handleChange={handleChange} handleBlur={handleBlur} />
					</div>

					<div className="key-value-card-container-key">Birth Date</div>
					<DateField
						name="dateOfBirth"
						label=""
						value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">Passport</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter passport number"
						name="passport"
						value={values.passport}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<div className="key-value-card-container-key">Nationality</div>
					<TextField
						className="input-blank-label"
						label=""
						placeholder="Enter nationality"
						name="nationality"
						value={values.nationality}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
				</form>
			)}
		</Formik>
	)
}
